/**
 * Caps for the free browser-only tools on the public site (/nastroje-zdarma).
 * They run on whatever a visitor drops in, so every input is bounded before it
 * is parsed: a wrong or hostile file must not freeze the tab. The app's own
 * imports keep their larger limits (e.g. MAX_GPC_BYTES in gpcParser.ts).
 */

/** Any file a free tool reads: far above a real statement or invoice. */
export const TOOL_MAX_FILE_BYTES = 10 * 1024 * 1024;

/** An ISDOC invoice's lines; real invoices have tens, e-shop ones hundreds. */
export const TOOL_MAX_INVOICE_LINES = 2000;

/** Entries in an .isdocx (a ZIP of the .isdoc and its PDF, maybe a few attachments). */
export const TOOL_MAX_ZIP_ENTRIES = 20;

/** The unpacked .isdoc inside an .isdocx, checked before it is inflated. */
export const TOOL_MAX_UNZIPPED_BYTES = 10 * 1024 * 1024;

export function isWithinFileCap(size: number): boolean {
  return Number.isFinite(size) && size >= 0 && size <= TOOL_MAX_FILE_BYTES;
}

/** Lines in the account ↔ IBAN converter's bulk box. */
export const TOOL_MAX_BULK_LINES = 1000;

/** One line of bulk input (an IBAN with spaces is 42 characters). */
export const TOOL_MAX_LINE_LENGTH = 64;
